
import { computed, defineComponent, onMounted, PropType, reactive, toRaw } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// validation
import useVuelidate from '@vuelidate/core'
import { CategoriesActionsValidation } from '@/modules/CouriersCategories/validations/CategoriesActions.validation'

//types
import { VehicleType } from '@/core/types/couriers.types'

export default defineComponent({
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isCreate: {
            type: Boolean,
            default: false,
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        isDelete: {
            type: Boolean,
            default: false,
        },
        initialValue: {
            type: Object as PropType<VehicleType>,
            default: null,
        },
    },
    components: {
        modal: Modal,
        'the-input': TheInput,
    },
    emits: ['create', 'update', 'delete', 'cancel'],
    setup(props, { emit }) {
        const state = reactive({
            name: null as string | null,
            volume: null as number | null,
            capacity: null as number | null,
        })

        const state_form$ = useVuelidate(CategoriesActionsValidation, state)

        const modalTitle = computed(() => {
            if (props.isCreate) return 'Добавление категории'
            if (props.isUpdate) return 'Редактирование категории'
            if (props.isDelete) return 'Удаление категории'
            return 'modal title'
        })

        const modalConfirmButtonText = computed(() => {
            if (props.isCreate) return 'Добавить'
            if (props.isUpdate) return 'Редактировать'
            if (props.isDelete) return 'Удалить'
            return 'Подтвердить'
        })

        onMounted(() => {
            if (!props.isUpdate) return

            state.name = props.initialValue.name
            state.volume = props.initialValue.volume
            state.capacity = props.initialValue.capacity

            state_form$.value.$reset()
        })

        /** create emit */
        const emitCreate = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('create', {
                name: state.name,
                volume: Number(state.volume),
                capacity: Number(state.capacity),
            })
        }

        /** update emit */
        const emitUpdate = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('update', {
                name: state.name,
                volume: Number(state.volume),
                capacity: Number(state.capacity),
            })
        }

        /** delete emit */
        const emitDelete = () => {
            emit('delete', props.initialValue.id)
        }

        const emitManager = () => {
            if (props.isCreate) emitCreate()
            if (props.isUpdate) emitUpdate()
            if (props.isDelete) emitDelete()
        }

        const emitCancel = () => {
            emit('cancel')
        }

        return { state, state_form$, modalTitle, modalConfirmButtonText, emitManager, emitCancel }
    },
})
